(function(){
 function start(){
  const bar=document.querySelector('[data-tc-eu-purchase]'),section=document.querySelector('#MainContent product-info');
  if(!bar||!section)return;
  const add=section.querySelector('button[name="add"]');if(!add)return;
  const cfg=JSON.parse(bar.querySelector('script[type="application/json"]').textContent),button=bar.querySelector('button'),summary=bar.querySelector('[data-tc-eu-total]');
  document.body.append(bar);
  function sync(){
   const cartOpen=Boolean(document.querySelector('cart-drawer.active,cart-notification.active'));
   if(bar.hidden!==cartOpen)bar.hidden=cartOpen;
   const quantity=Number(section.querySelector('input[name="quantity"]')?.value||1);
   const input=section.querySelector('.fixed-bundle-cards input[type="radio"]:checked');
   const card=input?.closest('label');
   const total=card?.querySelector('[data-offer-total]')?.textContent?.trim();
   const text=quantity+' '+(quantity===1?cfg.unit:cfg.units)+' · '+(total||'—');
   if(summary.textContent!==text)summary.textContent=text;
   if(button.disabled!==add.disabled)button.disabled=add.disabled;
   const label=add.disabled?cfg.unavailable:cfg.add;if(button.textContent!==label)button.textContent=label;
   const height=cartOpen?'0px':bar.getBoundingClientRect().height+'px';if(document.documentElement.style.getPropertyValue('--tc-eu-purchase-height')!==height)document.documentElement.style.setProperty('--tc-eu-purchase-height',height);
  }
  let frame;const queue=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync)};
  button.addEventListener('click',()=>{if(!add.disabled)add.click()});
  section.addEventListener('change',queue);section.addEventListener('input',queue);
  setInterval(()=>{if(!document.hidden)queue()},1000);
  
  window.addEventListener('resize',queue,{passive:true});sync();
  document.querySelectorAll('[data-tc-eu-top]').forEach(button=>button.addEventListener('click',()=>section.scrollIntoView({behavior:'smooth',block:'start'})));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
